const { reactive } = require('@vue/composition-api');

export const history = reactive([]);

export const historyMiddleware = function(router, onBackNavigation) {
  router.beforeEach((to, from, next) => {
    let lastRouteFromHistory = history[history.length - 1];
    if (lastRouteFromHistory?.name == to.name) {
      if (onBackNavigation) {
        history.pop();
        onBackNavigation();
      }
    } else {
      history.push(from);
    }

    if (history.length > 20) {
      history.shift();
    }
    next();
  });
};
